import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import posthog from 'posthog-js';
import { take } from 'rxjs';
import { ToLocaleFormat } from '../../../basic/pipes/to-locale-format.pipe';
import { GoalService } from '../../../core/goal/goal.service';
import { PostHogEvent } from '../../../core/posthog/posthog.event';
import { ResumeService } from '../../../core/resume/resume.service';
import { SessionTemplateService } from '../../../core/session-template/session.template.service';
import { Session, SESSION_LENGTH, SessionStatus } from '../../../core/session/session';
import { SessionService } from '../../../core/session/session.service';
import { MainSidebarComponent } from '../../../pages/_shared/main-sidebar/main-sidebar.component';
import { BoardIconTitleComponent } from '../../board/board-icon-title/board-icon-title.component';

@Component({
  selector: 'app-session-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzStatisticModule,
    NzButtonModule,
    MatTooltipModule,
    NzAvatarModule,
    NzPopconfirmModule,
    NzIconModule,
    MatTooltipModule,
    NzTableModule,
    NzTagModule,
    NzTabsModule,

    MainSidebarComponent,
    ToLocaleFormat,
    BoardIconTitleComponent,
  ],
  templateUrl: './session-table.component.html',
  styleUrl: './session-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionTableComponent {
  @Input({ required: true }) sessionList?: Session[];

  SessionStatus = SessionStatus;

  goalList = toSignal(this.goalService.goalList$(), { initialValue: [] });
  resumeList = toSignal(this.resumeService.resumeList$(), { initialValue: [] });
  sessionTemplateList = toSignal(this.sessionTemplateService.itemList$(), { initialValue: [] });

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private goalService: GoalService,
    private resumeService: ResumeService,
    private sessionTemplateService: SessionTemplateService
  ) {}

  getResume = (id?: string) => computed(() => this.resumeList().find((resume) => resume.id === id));
  getSessionTemplate = (id?: string) =>
    computed(() => this.sessionTemplateList().find((sessionTemplate) => sessionTemplate.id === id));

  isOngoing(session: Session) {
    return this.sessionService.isOngoing(session);
  }

  onViewReportClick(session: Session) {
    this.router.navigate(['', 'simulated-meetings', session.id], { queryParams: { tab: 'score' } });
  }

  onViewDetailsClick(session: Session) {
    this.router.navigate(['', 'simulated-meetings', session.id]);
  }

  onContinueSessionClick(session: Session) {
    posthog.capture(PostHogEvent.sessionContinue, { interviewId: session.id });
    this.router.navigate(['', 'practice', session.id]);
  }

  getLeftMinutes(session: Session) {
    return SESSION_LENGTH + (session.statusTime?.diffNow('minutes').minutes ?? 0);
  }

  onDeleteSessionClick(data: Session) {
    this.sessionService.deleteSession$(data).pipe(take(1)).subscribe();
  }
}
